import { IPagination } from '../IPagination';
import { API } from '../api';
import { IAccessPartner, ICreateAccessPartner, IFetchAccessPartnersQuery } from './interface';

export const fetchAccessPartners = async (
    { pagination, sorter, search }: IFetchAccessPartnersQuery,
    signal?: AbortSignal
): Promise<IPagination<IAccessPartner>> => {
    const limit = pagination?.pageSize || 1000;
    const current = pagination?.current || 1;
    const offset = (current - 1) * limit;

    if (sorter && (!sorter.field || !sorter.order)) {
        sorter = {};
    }

    const path = `/access-partners?${new URLSearchParams({
        ...(sorter?.field && { sortField: sorter.field, sortOrder: sorter.order }),
        ...(search && { search }),
        offset: offset.toString(),
        limit: limit.toString(),
    })}`;

    const response = await API.fetch(path, {
        signal,
        headers: {
            'Content-Type': 'application/json',
        },
    });

    if (response.ok) {
        return await response.json();
    }

    const failedRes = await response.json();

    throw new Error(failedRes?.error.message || `Cannot load list of program operators!`);
};

export const createAccessPartner = async (accessPartner: ICreateAccessPartner): Promise<IAccessPartner> => {
    const response = await API.fetch(`/access-partners`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(accessPartner),
    });

    if (response.ok) {
        return await response.json();
    }

    const failedRes = await response.json();

    throw new Error(failedRes?.error?.message || `Cannot create program operator!`);
};
